import Input2 from '../../../components/input2';
import SubmitBtn2,{SubmitBtn3} from '../../../components/submit2';
import sty from './s.module.scss';
import Header2 from '../../../components/header2';
import Footer2 from '../../../components/footer2';
//import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';
import Notif from '../../../components/notif';

import { loaderPostFetch } from '../util';
import React,{ useEffect, useState } from 'react';
//wpUser
import {wpUser,production} from '../../../../k';

import { Outlet, Link, useLoaderData, useActionData, Form } from 'react-router-dom';


export async function veaction({ request, params }) {
  //loader will fetch details
  const formData = await request.formData();
  formData.append("action","code");
  return formData;

  const updates = Object.fromEntries(formData);
  updates['action'] = 'code';
 

  const contact = await loaderPostFetch(`api/users.php?crud=verifyuser`, formData);

  return contact;
}
export async function veloader({ request,params }) {

 const url = new URL(request.url);
 const email = url.searchParams.get("email") || "";
 return {email};

  //const sessions = await getfetch(`${apiUrl}/sessionlist`, {});
  
  //return { ...params };
}

const Countdown = ({ initialTime ,setShowResend }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer); // Stop the timer once it reaches zero
          setShowResend(true);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(timer);
  }, [timeLeft]);

const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
};

return (
  <>
     {formatTime(timeLeft)} 
  </>
);

/*
  return (
    <div>
      <h2>Countdown: {timeLeft}s</h2>
    </div>
  );*/
};

export default function VerifyEmail() {
  const { email } = useLoaderData();

  const [showResend,setShowResend] = useState(false);


  let rData = useActionData();


  const [loading, setLoading] = useState(false);
  let [actionData,sactionData] = useState();

  useEffect(()=>{

    if(rData){
      console.log("this");
      setLoading(true);
      loaderPostFetch(`api/users.php?crud=verifyuser`, rData).then((c)=>{
        sactionData(c);
        setLoading(false);
      })
      .catch((e)=>{
setLoading(false);
      });

    } 

  },[rData]);
  //let actionData = useActionData();
  const [n, sN] = useState({ display: false, type: 'success', msg: '' });

  const resendcmail=()=>{

  }

  useEffect(() => {
    /*console.log({ actionData });*/
    if (actionData) {
      let s = actionData;

      console.log(s);
      if (s?.error) {
        //s?.message

        sN({ display: true, type: 'error', msg: `${s?.message}` });
        setTimeout(() => {
          sN({ display: false, type: 'error', msg: `` });
        }, 5000);
      } else {

        if (Object.keys(s).length!=1) {

        sN({ display: true, type: 'success', msg: `${s?.message}` });
        setTimeout(() => {
          sN({ display: false, type: 'success', msg: `` });

          if (s?.verification_status == 'Not Verified') {
            window.localStorage.setItem('account_verification', false);
            window.localStorage.setItem('tempbaUid', s?.jwt);

            window.location.href = `${wpUser}/account/kyc/form`;
          } else if (s?.verification_status == 'Pending Verification') {
            window.localStorage.setItem('account_verification', false);
            window.localStorage.setItem('tempbaUid', s?.jwt);

            window.location.href = `${wpUser}/account/kyc/under-review`;
          } else {
            window.localStorage.setItem('baUid', s?.jwt);
            //window.location.reload();
            sN({ display: true, type: 'success', msg: `${s?.message}` });
            setTimeout(() => {
              sN({ display: false, type: 'success', msg: `` });
              window.location.href = '${wpUser}/dashboard';
            }, 5000);
          }

        }, 5000);

      }else{
        sN({ display: true, type: 'error', msg: `Something went wrong` });
        setTimeout(() => {
          sN({ display: false, type: 'error', msg: `` });
        }, 5000);
      }
          /*
        window.localStorage.setItem('baUid', s?.jwt);
        //window.location.reload();
        sN({ display: true, type: 'success', msg: `${s?.message}` });
        setTimeout(() => {
          sN({ display: false, type: 'success', msg: `` });
          window.location.href = '../../dashboard';
        }, 5000);*/
      }

    }
  }, [actionData]);
  const resendCode = () => {
    //fetch()
    let formData = new FormData();
    if(email){
    formData.append('email', email);}
    formData.append('resendconfirmcode', 'resendconfirmcode');

    sN({ display: true, type: 'success0', msg: `Please Wait` });

    loaderPostFetch(`api/users.php`, formData)
      .then((d) => {
        sN({ display: true, type: 'success', msg: `Code Sent` });
        setTimeout(() => {
          sN({ display: false, type: 'error', msg: `` });
        }, 5000);
      })
      .catch((e) => {
        sN({ display: true, type: 'error', msg: `Something went wrong` });

        setTimeout(() => {
          sN({ display: false, type: 'error', msg: `` });
        }, 5000);
      });
  };

  return (
    <div>
      <Notif display={n?.display} type={n?.type} msg={n?.msg} />

      <Header2 href={`../${window['login']}`} title="Sign In" />

      <div className={sty.sub}>
        <div className={sty.text}>Email Verification</div>

        <div className={sty.lock}></div>
      </div>

      <div className={sty.s}>
        we have sent code your mail{/*:
        <br />
        {email}*/}
      </div>
      <Form method="post">
        <input type="hidden" name="email" value={email} />
        <Input2 type="text" name="ver_code" placeholder="Enter Code" />

        {/*<div className={sty.remeber}>
		<div className={sty.l}>
		<input type="checkbox" />
		<div className={sty.text}>I&apos;m at least 18 years old and agree to the following terms:</div>
		</div>
		<div className={sty.r}>
		<a href="">Forgot Password?</a>
		</div>
		</div>

		<div className={sty.note}>
By tapping Next. I've read and agree to the  
		<div className={sty.imp}>E-Sign Disclosure and Consent 
		</div>to receive all communications  electronically

		</div>*/}

        <SubmitBtn3 label="Confirm Code" loading={loading} /> 
      </Form>

      <div className={sty.resend} style={{ textAlign: 'center', color: '#19202F',  fontWeight: '400', wordWrap: 'break-word'}}>
      Didn’t receive it? Check your spam or junk folder.<br/>Still no code? Click 
 "{showResend ? <span style={{color: '#31AE66','cursor':'pointer'}} onClick={()=>{
   resendCode();setShowResend(false);
 }}>Resend</span>:
<Countdown initialTime={180} setShowResend={setShowResend} />}" .</div>
        
      {/*<div
        className={sty.resend}
        onClick={() => {
          resendCode();
        }}
      >
        Haven’t gotten the mail yet? <a>Resend</a>


      </div>*/}

      <Footer2 />
    </div>
  );
}
